const checkboxs = document.querySelectorAll("#formOffer [data-checkbox-wrapper]");

if (checkboxs) {
  checkboxs.forEach((checkbox) => {
    checkbox.addEventListener("click", () => {
      if (checkbox.querySelector('input[type="checkbox"]').checked) {
        checkbox.classList.add("active");
      } else {
        checkbox.classList.remove("active");
      }
    });
  });
}
